import { deliveryBox, userPlaceholder } from "assets/icons";
import { downloadIcon } from "assets/images";
import { Select } from "common/InputForm";
import useFullPageLoader from "common/UseFullPageLoader";
import React, { useEffect, useState } from "react";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import { orderDetailsApi, updateAddressApi } from "services/orderManagement";

import { capitalizeFirst, formatPrice } from "utils/common";
import { dateFormat, formatCustomDate } from "utils/dateFormat";
import ChangeOrderStatus from "./ChangeOrderStatus";
import DeliveryStatus from "./DeliveryStatus";
import Rating from "./Rating";
import { IoMdCloudDownload } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi"; // ✅ edit icon
import EditAddressModal from "./EditAddressModal"; // ✅ import modal
import { IoChevronBack } from "react-icons/io5";

const OrderDetails = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState({});
  const [showEditAddress, setShowEditAddress] = useState(false);

  //save address
  const handleSaveAddresss = async (formData) => {
    // Call API
    await updateAddressApi(orderId, formData);

    // Update local state instantly (optimistic update)
    setOrderDetails((prev) => ({
      ...prev,
      addressDetails: {
        ...prev.addressDetails,
        ...formData,
      },
    }));

    // await fetchOrderDetails();
  };

  const handleSaveAddress = (formData) => {
    setOrderDetails((prev) => ({
      ...prev,
      addressDetails: {
        ...prev.addressDetails,
        ...formData,
      },
    }));
  };

  console.log("orderDetails", orderDetails);
  const handleDownload = (url) => {
    console.log("Downloading file from URL:", url);
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = url?.split("/").pop(); // Optional: sets filename from URL
    link.target = "_blank"; // Optional: open in new tab if not downloadable
    document.body.appendChild(link);
    link.click();
    console.log("Download initiated for URL:", url);
    document.body.removeChild(link);
  };

  // -------download prescription image (blob, so remote urls really save)------
  const handleImageDownload = async (url, fileName) => {
    if (!url) return;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // fallback: open in a new tab if the file can not be fetched (CORS etc.)
      window.open(url, "_blank");
    }
  };
  // -------------details-Api------------------
  const fetchOrderDetails = async () => {
    try {
      onShow();
      const res = await orderDetailsApi(orderId);
      const { code, data } = res?.data;
      if (code === 200) {
        setOrderDetails(data || {});
      }
    } catch (error) {
      console.log(error);
    } finally {
      onHide();
    }
  };
  useEffect(() => {
    if (orderId) {
      fetchOrderDetails();
    }
  }, []); // ------------details-api------------

  return (
    <div className="user-mgm-details-container">
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Order Management</span>
          &nbsp;
          <span>/ Order Details </span>
        </p>
      </div>
      <div className="card order-details-data">
        {loader}
        <div className="container border rounded-3 p-4 my-3 shadow-sm bg-white">
          <div className="d-flex justify-content-between align-items-start flex-wrap">
            <h5 className="mb-2 fw-semibold">
              Order {orderDetails?.orderId ? `#${orderDetails?.orderId}` : "N/A"}
            </h5>
            <h4 className="text-center flex-grow-1 mb-2 fw-bold">
              Order Details
            </h4>
            {/* <button onClick={() => handleDownload(orderDetails?.invoice)} disabled={orderDetails?.orderStatus !== "DELIVERED"} className="text-end mb-2">
                            <IoMdCloudDownload className='w-50 me-4 fs-1' />
                            <div className="small">Download Invoice</div>
                        </button> */}

            <button
              onClick={() => handleDownload(orderDetails?.invoice)}
              disabled={orderDetails?.orderStatus == "PENDING"}
              className="text-end mb-2"
            >
              <IoMdCloudDownload className="w-50 me-4 fs-1" />
              <div className="small">Download Invoice</div>
            </button>
          </div>
          <b className="mb-4">Sindhi Medical Store</b>
          <div className="row">
            <div className="col-6 text-dark">
              <p className="mb-2 fw-medium">Customer Name</p>
              <p className="mb-2 fw-medium">Order Date and Time</p>
              <p className="mb-2 fw-medium">Payment Status</p>
              <p className="mb-2 fw-medium">Order Type</p>
                            <p className="mb-2 fw-medium">Mobile No.</p>

            </div>
            <div className="col-6 text-end">
              <p className="mb-2 fw-semibold ">
                {capitalizeFirst(orderDetails?.user?.fullName) || "N/A"}
              </p>
              <p className="mb-2 fw-semibold ">
                {formatCustomDate(
                  orderDetails?.createdAt,
                  "YYYY-MM-DD hh:mm A",
                ) || "N/A"}
              </p>
              <p className="mb-2 fw-semibold ">
                {capitalizeFirst(orderDetails?.paymentStatus) || "N/A"}
              </p>
              <p className="mb-2 fw-semibold ">
                {capitalizeFirst(
                  orderDetails?.orderType == "DELIVERY"
                    ? "Home Delivery"
                    : orderDetails?.orderType,
                ) || "N/A"}
              </p>

                <p className="mb-2 fw-semibold ">

                     {
                  orderDetails?.user?.phone? orderDetails?.user?.countryCode: ""}
                {
                  orderDetails?.user?.phone? orderDetails?.user?.phone: "N/A"}
               
              </p>
            </div>
          </div>
        </div>
        {/* --------------Ordered-Items----------------- */}
        <div
          className="border rounded-3 p-3 shadow-sm"
          style={{ borderWidth: "2px" }}
        >
          <h6 className="text-primary fw-semibold mb-2">
            {orderDetails?.products && orderDetails?.products.length} Ordered
            Items
          </h6>
          <hr />
          <div className="product_list update_width">
            <ul>
              <li>
                <b>S.No.</b>
              </li>
              <li>
                <b>Image</b>
              </li>
              <li>
                <b>Items</b>
              </li>
              <li>
                <b>Product ID</b>
              </li>
              <li>
                <b>Packing unit</b>
              </li>
              <li>
                <b>MRP</b>
              </li>
              <li>
                <b>Sale Price</b>
              </li>
              <li>
                <b>Type</b>
              </li>
              <li>
                <b>Quantity</b>
              </li>
              <li>
                <b>Amount</b>
              </li>
            </ul>
            {orderDetails?.products &&
              orderDetails?.products.length > 0 &&
              orderDetails?.products?.map((item, index) => (
                <ul key={index}>
                  {/* <li> */}
                  {/* <div className='content'> */}
                  <li>{++index}</li>
                  <li>
                    <img src={item?.image?.[0]} alt="" />
                  </li>
                  <li> {item?.name || "N/A"}</li>
                  {/* <p>
                                                <b>
                                                    {item?.name}
                                                    {item?.productType?.name || ''}{' '}
                                                    {item?.variant?.quantity}
                                                    {item?.variant?.unit}
                                                </b>
                                                <span></span>
                                            </p> */}
                  {/* </div> */}

                  {/* </li> */}
                  <li>{item?.productCustomId || "N/A"}</li>
                  <li>{item?.productType?.name || "N/A"}</li>
                  <li>{formatPrice(item?.variant?.mrp) || "N/A"}</li>
                  <li>{formatPrice(item?.variant?.finalAmount) || "N/A"}</li>

                  <li>{item?.itemType || "N/A"}</li>

                  <li>{item?.quantity || "N/A"}</li>
                  <li>
                    {item?.variant?.finalAmount != null &&
                    item?.quantity != null
                      ? item.variant.finalAmount * item.quantity
                      : "N/A"}
                  </li>
                </ul>
              ))}
          </div>
        </div>
        {/* --------------Prescription-Items----------------- */}
        {(orderDetails?.prescription?.length > 0 ||
          orderDetails?.description) && (
          <div
            className="border rounded-3 p-3 shadow-sm mt-3"
            style={{ borderWidth: "2px" }}
          >
            <div className="container my-4">
              <div className="row align-items-start">
                {/* Prescription Section */}
                {orderDetails?.prescription &&
                  orderDetails?.prescription?.length > 0 && (
                    <div className="col-md-6">
                      <h5 className="fw-bold mb-3">Prescription uploaded</h5>
                      <div className="d-flex flex-wrap gap-3">
                        {orderDetails.prescription.map((img, index) => (
                          <div
                            key={index}
                            className="prescription-img-box position-relative"
                          >
                            <img
                              src={img}
                              alt={`prescription-${index}`}
                              className="img-fluid rounded shadow-sm"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                              }}
                            />
                            <button
                              type="button"
                              title="Download"
                              className="btn btn-light border rounded-circle p-0 d-flex align-items-center justify-content-center position-absolute top-0 end-0 m-1 shadow-sm"
                              style={{ width: 26, height: 26 }}
                              onClick={() =>
                                handleImageDownload(
                                  img,
                                  `prescription-${orderDetails?.orderId || orderId}-${index + 1}.jpg`
                                )
                              }
                            >
                              <FaCloudDownloadAlt
                                size={13}
                                className="text-primary"
                              />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* Description Section */}
                {orderDetails?.description && (
                  <div className="col-md-6">
                    <h5 className="fw-bold mb-3">Description</h5>
                    <div
                      className="bg-light p-3 rounded shadow-sm"
                      style={{ minHeight: "150px" }}
                    >
                      <p className="mb-2" style={{ whiteSpace: "pre-line" }}>
                        {orderDetails.description}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* --------------------------cost-summary------------------------------ */}
        <div
          className="p-4 rounded-4 mb-4 mt-3"
          style={{ backgroundColor: "#f4eaff" }}
        >
          <div className="bg-white rounded-3 p-4 shadow-sm">
            <h6 className="fw-bold mb-3">Cost Summary</h6>
            <hr />
            <div className="d-flex justify-content-between mb-2">
              <span>MRP</span>
              <span>{orderDetails?.mrp ? `₹${orderDetails?.mrp}` : "0.00"}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Discount</span>
              <span className="text-danger">
                {orderDetails?.saving ? `-₹${orderDetails?.saving}` : "0.00"}
              </span>
            </div>
               <div className="d-flex justify-content-between mb-2">
              <span>Sub Total </span>
              <span>
                {orderDetails?.grossTotal
                  ? `₹${orderDetails?.grossTotal}`
                  : "N/A"}
              </span>
            </div>
               <div className="d-flex justify-content-between mb-2">
              <span>Coupon Discount</span>
              <span className="text-success">
                {orderDetails?.couponAmount
                  ? `-₹${orderDetails?.couponAmount}`
                  : "0.00"}
              </span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Coins Discount</span>
              <span className="text-success">
                {orderDetails?.coinAmount
                  ? `-₹${orderDetails?.coinAmount}`
                  : "0.00"}
              </span>
            </div>
         
         
            <div className="d-flex justify-content-between mb-3">
              <span>Delivery Charges </span>
              <span>
                {orderDetails?.deliveryCharge
                  ? `+ ₹${orderDetails?.deliveryCharge}`
                  : "0.00"}
              </span>
            </div>
            <hr />
            <div className="d-flex justify-content-between fs-5 fw-bold">
              <span>Total Amount</span>
              {/* <span>₹1364</span> */}
              <span>
                {orderDetails?.total ? `₹${orderDetails?.total}` : "0.00"}
              </span>
            </div>
          </div>
        </div>

        {/* --------------------------Address-Details ------------------------------ */}
        {orderDetails?.orderType !== "PICKUP" && (
          <div
            className="border rounded-3 p-3 shadow-sm dit-btn-data"
            style={{ borderWidth: "2px" }}
          >
            <h6 className="fw-bold mb-2">Address Details</h6>

            {/* {orderStatus !==
                                   <button
                                className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                onClick={() => setShowEditAddress(true)}
                            >
                                <FiEdit2 size={14} />
                                <span>Edit</span>
                            </button>

                             } */}

            {orderDetails.orderStatus !== "DELIVERED" && (
              <button
                className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                onClick={() => setShowEditAddress(true)}
              >
                <FiEdit2 size={14} />
                <span>Edit</span>
              </button>
            )}
            <div className="fw-semibold">
              {orderDetails?.addressDetails?.type}
            </div>
            <div className="text-muted small">
              Address: {orderDetails?.addressDetails?.address} | Landmark:{" "}
              {orderDetails?.addressDetails?.landmark} | House No.:{" "}
              {orderDetails?.addressDetails?.floor}
            </div>
          </div>
        )}

        {/* --------------------------Contact-Info------------------------------ */}
       {orderDetails?.orderStatus === "CANCELLED" && (
  <div
    className="border rounded-3 p-3 shadow-sm mt-3"
    style={{ borderWidth: "2px" }}
  >
    <div className="fw-semibold">Cancellation Reason</div>
    <div className="text-muted">
      {orderDetails?.reason || "N/A"}
    </div>
  </div>
)}
        {/* --------------------------Rating------------------------------ */}
        {orderDetails?.orderStatus === "DELIVERED" &&
          orderDetails?.orderType !== "PICKUP" && (
            <Rating {...{ rating: orderDetails?.rating }} />
          )}

        {/* --------------------------Delivery-Info------------------------------ */}
        <DeliveryStatus
          orderDetails={orderDetails}
          orderId={orderId}
          listing={fetchOrderDetails}
        />
      </div>

      {/* <EditAddressModal
                show={showEditAddress}
                onClose={() => setShowEditAddress(false)}
                addressDetails={orderDetails?.addressDetails}
                onSave={handleSaveAddress}
            /> */}

      {/* <EditAddressModal
  show={showEditAddress}
  onClose={() => setShowEditAddress(false)}
  addressDetails={orderDetails?.addressDetails}
    orderId={orderId}

  onSave={handleSaveAddress}
/> */}

      <EditAddressModal
        show={showEditAddress}
        onClose={() => setShowEditAddress(false)}
        addressDetails={{
          ...orderDetails?.addressDetails,
          _id: orderDetails?.addressId,
        }}
        orderId={orderId}
        onSave={handleSaveAddress}
      />
    </div>
  );
};

export default OrderDetails;
